import { useLocation, useParams } from 'react-router';

const useSubmittalId = () => {
	const { submittalId } = useParams();
	const location = useLocation();

	if (submittalId) {
		return submittalId;
	}

	return new URLSearchParams(location.search.toLowerCase()).get('submittalid');
};

export default useSubmittalId;
